import { formatDateRange } from '../utils/misc';
import './DateRangeBadge.scss';

export default function DateRangeBadge({ start, end }) {
  return (
    <div className='date-range-badge badge'>
      <span className='fa-calendar' />
      {formatDateRange(start, end)}
    </div>
  );
}
